const brItem = {
  item: {
    label: {
      name: 'Name',
      category: 'Category',
      description: 'Description',
      preset: 'Is preset',
      createdAt: 'Created at',
      true: 'Yes',
      false: 'No',
    },

    action: {
      cancel: 'Cancel',
      add: 'Add item',
      edit: 'Edit item',
      create: 'Create item',
      delete: 'Delete item',
      loading: 'Loading item',
    },

    hints: {
      delete: 'Do you really want to delete this item?',
      deleteWarning: 'The item will be removed from all price tables.',
    },

    messages: {
      successfullyCreated: 'Item created successfully',
      successfullyUpdated: 'Item updated successfully',
      successfullyDeleted: 'Item removed successfully',
    },
  },
};

export default brItem;
